import { PagePerformedByRequestDTO } from './page-performed-by-request-dto';

export interface ReadContextRoleProfileApproverRolesRequestDTO extends PagePerformedByRequestDTO {
    contextName?: string;
    roleName?: string;
    approverRoles?: string;
    idbApps?: string;
}
